import { Helmet } from "react-helmet";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";
import BreadCrumbSecurityInformation from "../../components/securityInformation/BreadCrumbSecurityInformation";
import Content from "../../components/securityInformation/Content";

export default function SecurityInformation() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Kebijakan Keamanan Informasi - BPR Palu Anugerah</title>
                <meta name="description" content="Kebijakan Keamanan Informasi BPR Palu Anugerah" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Kebijakan Keamanan Informasi - BPR Palu Anugerah" />
                <meta property="og:description" content="Kebijakan Keamanan Informasi BPR Palu Anugerah." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbSecurityInformation></BreadCrumbSecurityInformation>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}